import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import authSlice from '../slices/authSlice';
import candidateSlice from '../slices/candidateSlice';
import preferencesSlice from '../slices/preferencesSlice';
import querySlice from '../slices/querySlice';
import reportSlice from '../slices/reportSlice';
import roleSlice from '../slices/roleSlice';
import taxonomySlice from '../slices/taxonomySlice';
import teamSlice from '../slices/teamSlice';
import userSlice from '../slices/userSlice';
import utilSlice from '../slices/utilSlice';
import dashboardSlice from '../slices/dashboardSlice';
import documentSlice from '../slices/documentSlice';
import tenantSlice from '../slices/tenantSlice';
import dataSourceSlice from '../slices/dataSourceSlice';
import statusSlice from '../slices/statusSlice';
import { resetAppState } from './appActions';

// CHKM-4023 round 2 (Item 5): resetAppState now lives in the leaf module
// `appActions.ts` (which imports nothing from `store` or any slice) so that
// `authSlice.ts` can import it without re-introducing a value-level
// `authSlice -> store` import edge. Re-exported here so any existing import of
// `resetAppState` from `./store` keeps working.
export { resetAppState };

const appReducer = combineReducers({
  auth: authSlice,
  candidate: candidateSlice,  
  preferences: preferencesSlice,
  query: querySlice,
  dashboard: dashboardSlice,
  document: documentSlice,
  report: reportSlice,
  role: roleSlice,
  taxonomy: taxonomySlice,
  team: teamSlice,
  tenant: tenantSlice,
  user: userSlice,
  util: utilSlice,
  dataSource: dataSourceSlice,
  status: statusSlice
});

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    state = undefined;
  }
  return appReducer(state, action);
}

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
          serializableCheck: false
      }),
  devTools: true
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
